import { useState, useMemo, useEffect } from "react";
import { useGetAvailableQuestions, useGetSetup, useSession } from "@/hooks";
import { AssessmentWorkflow } from "./assessment.workflow";
import { MainWorkflow } from "./setup-workflow";
import { WorkflowLoading } from "./components/WorkflowLoading/workflow-loading";
import { OverviewWorkflow } from "./overview.workflow";
import { useNavigate } from "react-router-dom";

enum Workflow {
  ASSESSMENT = "assessment",
  OVERVIEW = "overview",
  MAIN_WORKFLOW = "main_workflow",
}

export const WorkflowsPage = () => {
  const navigate = useNavigate();
  const { companyId } = useSession();
  const { questions, isInitialLoading } = useGetAvailableQuestions(companyId);
  const { refetch: refetchSetup } = useGetSetup(companyId);

  const shouldShowAssessment = useMemo(() => {
    return questions && questions.moduleAssessment;
  }, [questions]);

  const initialFlow = useMemo(() => {
    return shouldShowAssessment ? Workflow.ASSESSMENT : Workflow.OVERVIEW;
  }, [shouldShowAssessment]);

  const [currentFlow, setCurrentFlow] = useState<Workflow>(initialFlow);

  useEffect(() => {
    if (!isInitialLoading && currentFlow !== initialFlow) {
      setCurrentFlow(initialFlow);
    }
  }, [isInitialLoading, initialFlow]);

  const handleAssessmentComplete = () => {
    setCurrentFlow(Workflow.OVERVIEW);
  };

  const handleOverviewComplete = () => {
    setCurrentFlow(Workflow.MAIN_WORKFLOW);
  };

  const handleMainWorkflowComplete = () => {
    refetchSetup();
    navigate("/home");
  };

  if (isInitialLoading) {
    return <WorkflowLoading />;
  }

  const renderCurrentFlow = () => {
    switch (currentFlow) {
      case Workflow.ASSESSMENT:
        return (
          <AssessmentWorkflow onWorkflowComplete={handleAssessmentComplete} />
        );

      case Workflow.OVERVIEW:
        return <OverviewWorkflow onNext={handleOverviewComplete} />;

      case Workflow.MAIN_WORKFLOW:
        return <MainWorkflow onWorkflowComplete={handleMainWorkflowComplete} />;

      default:
        return null;
    }
  };

  return renderCurrentFlow();
};
